const STORAGE_KEY = 'gokay_wishlist';

const HEART_PATH =
  'M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z';

const CART_ICON_SVG =
  '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" d="M2.25 3h1.386c.51 0 .955.343 1.087.835l.383 1.437M7.5 14.25a3 3 0 00-3 3h15.75m-12.75-3h11.218c1.121-2.3 2.1-4.684 2.924-7.138a60.114 60.114 0 00-16.536-1.84M7.5 14.25L5.106 5.272M6 20.25a.75.75 0 11-1.5 0 .75.75 0 011.5 0zm12.75 0a.75.75 0 11-1.5 0 .75.75 0 011.5 0z"/></svg>';

const EYE_ICON_SVG =
  '<svg class="custom-eye-btn__svg" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" d="M2.036 12.322a1.012 1.012 0 010-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178z"/><path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"/></svg>';

/**
 * @param {number} cents
 * @param {string} format
 * @returns {string}
 */
function formatMoney(cents, format) {
  const amount = (Number(cents) / 100).toFixed(2);
  const parts = amount.split('.');
  const whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  const fraction = parts[1];

  if (format.includes('{{amount_with_comma_separator}}')) {
    return format.replace('{{amount_with_comma_separator}}', `${whole},${fraction}`);
  }

  if (format.includes('{{amount_no_decimals}}')) {
    return format.replace('{{amount_no_decimals}}', whole);
  }

  return format.replace('{{amount}}', `${whole},${fraction}`);
}

/**
 * @returns {string[]}
 */
function getWishlistHandles() {
  if (window.Wishlist?.getWishlist) {
    return window.Wishlist.getWishlist();
  }

  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
  } catch {
    return [];
  }
}

/**
 * @param {string[]} handles
 */
function persistWishlist(handles) {
  if (window.Wishlist?.saveWishlist) {
    window.Wishlist.saveWishlist(handles);
    return;
  }

  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(handles));
  } catch {
    /* ignore */
  }
}

/**
 * @param {string} value
 * @returns {string}
 */
function escapeHtml(value) {
  return String(value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

/**
 * @param {object} product
 * @returns {object | null}
 */
function getFirstAvailableVariant(product) {
  if (!product?.variants?.length) return null;
  return product.variants.find((variant) => variant.available) || product.variants[0];
}

/**
 * @param {object} product
 * @returns {string}
 */
function getInstallmentLabel(product) {
  const price = Number(product.price);
  if (price >= 1000000) return 'Peşin Fiyatına 3 Taksit';
  if (price >= 500000) return 'Peşin Fiyatına 2 Taksit';
  return '';
}

/**
 * @param {object} product
 * @returns {string}
 */
function getShippingMessage(product) {
  const tags = Array.isArray(product.tags) ? product.tags : [];
  if (
    tags.some((tag) =>
      ['aynı-gün-kargo', 'same-day-shipping', 'Aynı Gün Kargo'].includes(String(tag))
    )
  ) {
    return 'Aynı Gün Kargo';
  }
  return 'Ücretsiz Kargo';
}

/**
 * @param {object} product
 * @param {string} moneyFormat
 * @returns {string}
 */
function renderPriceHtml(product, moneyFormat) {
  const compareAt = Number(product.compare_at_price);
  const price = Number(product.price);
  const showCompare = product.available && compareAt > price;

  if (showCompare) {
    return `<span role="group"><span class="visually-hidden">İndirimli fiyat&nbsp;</span><span class="price">${formatMoney(price, moneyFormat)}</span></span><span role="group"><span class="visually-hidden">Normal fiyat&nbsp;</span><span class="compare-at-price">${formatMoney(compareAt, moneyFormat)}</span></span>`;
  }

  return `<span class="price">${formatMoney(price, moneyFormat)}</span>`;
}

/**
 * @param {object} product
 * @param {object | null} variant
 * @param {string} moneyFormat
 * @param {string} popupId
 * @returns {string}
 */
function renderQuickViewModal(product, variant, moneyFormat, popupId) {
  const images = Array.isArray(product.images) && product.images.length ? product.images : product.featured_image ? [product.featured_image] : [];
  const showCompare = Number(product.compare_at_price) > Number(product.price);
  const shippingMessage = getShippingMessage(product);
  const slides = images
    .map(
      (src) =>
        `<div class="modal-gallery__slide" data-gallery-slide><img src="${src}${src.includes('?') ? '&' : '?'}width=800" alt="${escapeHtml(product.title)}" loading="lazy"></div>`
    )
    .join('');

  return `
    <div class="custom-modal-template" data-quick-view-template hidden>
      <div class="custom-modal-overlay">
        <div class="custom-modal-content">
          <button type="button" class="custom-modal-close" aria-label="Kapat">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12"/></svg>
          </button>
          <div class="modal-product-info">
            <div class="modal-gallery" data-modal-gallery${images.length < 2 ? ' data-gallery-single' : ''}>
              <div class="modal-gallery__viewport" data-gallery-viewport>
                <div class="modal-gallery__track" data-gallery-track>${slides || '<div class="modal-gallery__slide" data-gallery-slide></div>'}</div>
              </div>
            </div>
            <div class="modal-text-wrapper">
              <div class="modal-text-wrapper__body">
                <h2 class="modal-product-title">${escapeHtml(product.title)}</h2>
                <div class="modal-product-price">
                  ${showCompare ? `<span class="modal-product-price__compare">${formatMoney(product.compare_at_price, moneyFormat)}</span>` : ''}
                  <span class="modal-product-price__current">${formatMoney(product.price, moneyFormat)}</span>
                </div>
                <p class="modal-shipping-incentive">${shippingMessage}</p>
              </div>
              <div class="modal-text-wrapper__footer modal-sticky-footer">
                <form method="post" action="/cart/add" class="modal-add-form" id="modal-form-${popupId}">
                  <input type="hidden" name="id" value="${variant?.id || ''}">
                  <input type="hidden" name="quantity" value="1">
                  <button type="submit" class="modal-add-btn"${variant?.available ? '' : ' disabled'}>
                    <span class="modal-add-btn__text">Sepete ekle</span>
                  </button>
                </form>
                <a href="${product.url}" class="modal-details-link">Tüm detayları görüntüle</a>
              </div>
            </div>
          </div>
        </div>
        <div class="overlay-click-area" aria-hidden="true"></div>
      </div>
    </div>
  `;
}

/**
 * @param {object} product
 * @param {string} moneyFormat
 * @param {string} sectionId
 * @returns {string}
 */
function renderProductCard(product, moneyFormat, sectionId) {
  const variant = getFirstAvailableVariant(product);
  const canAdd = Boolean(variant?.available);
  const addLabel = canAdd ? 'Sepete ekle' : 'Tükendi';
  const imageUrl = product.featured_image || product.images?.[0] || '';
  const imageSrc = imageUrl ? `${imageUrl}${imageUrl.includes('?') ? '&' : '?'}width=600` : '';
  const installmentLabel = getInstallmentLabel(product);
  const showSaleBadge = product.available && Number(product.compare_at_price) > Number(product.price);
  const showFeaturedBadge =
    Array.isArray(product.tags) &&
    (product.tags.includes('featured') || product.tags.includes('öne-çıkan'));
  const formId = `Wishlist-ProductForm-${sectionId}-${product.id}`;
  const popupId = `wishlist-${sectionId}-${product.id}`;

  return `
    <li class="product-grid__item wishlist-page__item" data-product-handle="${product.handle}">
      <product-card class="product-card" data-product-id="${product.id}">
        <a href="${product.url}" class="product-card__link">
          <span class="visually-hidden">${escapeHtml(product.title)}</span>
        </a>
        <div class="product-card__content layout-panel-flex layout-panel-flex--column product-grid__card spacing-style border-style gap-style">
          ${showFeaturedBadge ? '<span class="product-card__featured-badge">Öne Çıkan</span>' : ''}
          <div class="card-gallery" style="--gallery-aspect-ratio: 4 / 5;">
            ${
              showSaleBadge
                ? '<div class="product-badges product-badges--top-left"><div class="product-badges__badge product-badges__badge--rectangle">İndirim</div></div>'
                : ''
            }
            <a href="${product.url}" class="product-media" tabindex="-1" aria-hidden="true">
              ${
                imageSrc
                  ? `<img class="product-media__image" src="${imageSrc}" alt="${escapeHtml(product.title)}" loading="lazy" width="600" height="750">`
                  : '<div class="wishlist-page__media-placeholder" aria-hidden="true"></div>'
              }
            </a>
          </div>
          <div class="product-card__gallery-actions" style="--card-media-height: calc(100cqw * 1.25);">
            <div class="product-promo-pills product-promo-pills--card">
              <span class="product-promo-pill product-promo-pill--shipping">
                <span class="product-promo-pill__dot" aria-hidden="true"></span>
                <span class="product-promo-pill__label">Ücretsiz Kargo</span>
              </span>
              ${
                installmentLabel
                  ? `<span class="product-promo-pill product-promo-pill--installment"><span class="product-promo-pill__dot" aria-hidden="true"></span><span class="product-promo-pill__label">${installmentLabel}</span></span>`
                  : ''
              }
            </div>
            <button type="button" class="wishlist-heart-icon product-card__wishlist-btn is-active" data-product-handle="${product.handle}" aria-label="Favorilerden çıkar">
              <svg class="wishlist-heart-icon__svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="#2a2a2a" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">
                <path fill="none" d="${HEART_PATH}" />
              </svg>
            </button>
            <div class="card-gallery__quick-add-wrap" data-quick-view-root>
              <button type="button" class="custom-eye-btn" data-quick-view-trigger aria-label="Hızlı Bakış">
                <span class="custom-eye-btn__track">
                  <span class="custom-eye-btn__label-wrap" aria-hidden="true">
                    <span class="custom-eye-btn__label">Hızlı Bakış</span>
                  </span>
                  <span class="custom-eye-btn__icon-wrap">${EYE_ICON_SVG}</span>
                </span>
              </button>
              ${renderQuickViewModal(product, variant, moneyFormat, popupId)}
            </div>
          </div>
          <a class="contents user-select-text" href="${product.url}"><p>${escapeHtml(product.title)}</p></a>
          <product-price><div ref="priceContainer">${renderPriceHtml(product, moneyFormat)}</div></product-price>
          <span class="buy-buttons-block product-card__cta">
            <product-form-component data-section-id="${sectionId}" data-product-id="${product.id}" data-product-title="${escapeHtml(product.title)}" data-product-url="${product.url}" data-quantity-default="1">
              <form id="${formId}" action="/cart/add" method="post" accept-charset="UTF-8" enctype="multipart/form-data" data-type="add-to-cart-form" class="wishlist-page__add-form">
                <input type="hidden" name="form_type" value="product">
                <input type="hidden" name="utf8" value="✓">
                <input type="hidden" name="id" value="${variant?.id || ''}">
                <div class="product-form-buttons">
                  <add-to-cart-component data-product-variant-media="${imageSrc ? imageSrc.replace(/width=\d+/, 'width=100') : ''}">
                    <button type="submit" name="add" class="button add-to-cart-button" ${canAdd ? '' : 'disabled'} data-product-title="${escapeHtml(product.title)}" data-product-image="${imageSrc}">
                      <span class="add-to-cart-text">
                        ${canAdd ? `<span aria-hidden="true" class="svg-wrapper add-to-cart-icon add-to-cart-icon--simple-cart">${CART_ICON_SVG}</span>` : ''}
                        <span class="add-to-cart-text__content"><span><span>${addLabel}</span></span></span>
                      </span>
                    </button>
                  </add-to-cart-component>
                </div>
              </form>
            </product-form-component>
          </span>
        </div>
      </product-card>
    </li>
  `;
}

/**
 * @param {number} count
 * @returns {string}
 */
function renderSkeletons(count) {
  const items = Math.min(Math.max(count, 2), 8);
  let html = '';

  for (let i = 0; i < items; i += 1) {
    html += `
      <li class="product-grid__item wishlist-page__item wishlist-page__item--skeleton" aria-hidden="true">
        <div class="wishlist-page__skeleton-card">
          <div class="wishlist-page__skeleton-media"></div>
          <div class="wishlist-page__skeleton-line wishlist-page__skeleton-line--title"></div>
          <div class="wishlist-page__skeleton-line wishlist-page__skeleton-line--price"></div>
          <div class="wishlist-page__skeleton-line wishlist-page__skeleton-line--button"></div>
        </div>
      </li>
    `;
  }

  return html;
}

class WishlistPage {
  /** @type {HTMLElement | null} */
  #root = null;

  /** @type {HTMLElement | null} */
  #grid = null;

  /** @type {HTMLElement | null} */
  #empty = null;

  /** @type {string} */
  #moneyFormat = '{{amount}}';

  /** @type {string} */
  #sectionId = '';

  /** @type {boolean} */
  #loading = false;

  init() {
    this.#root = document.querySelector('[data-wishlist-page]');
    if (!this.#root) return;

    this.#grid = this.#root.querySelector('[data-wishlist-grid]');
    this.#empty = this.#root.querySelector('[data-wishlist-empty]');
    this.#moneyFormat = this.#root.dataset.moneyFormat || '{{amount}}';
    this.#sectionId = this.#root.dataset.sectionId || 'wishlist';

    this.#root.addEventListener('submit', this.#handleAddToCart);
    document.addEventListener('wishlist:change', this.#handleWishlistChange);

    if (typeof window.initCustomQuickView === 'function') {
      window.initCustomQuickView();
    }

    void this.#render();
  }

  /** @param {SubmitEvent} event */
  #handleAddToCart = (event) => {
    const form = event.target instanceof HTMLFormElement ? event.target : null;
    if (!form || !form.classList.contains('wishlist-page__add-form')) return;

    event.preventDefault();

    if (!window.Theme?.routes?.cart_add_url) {
      form.submit();
      return;
    }

    const submitBtn = form.querySelector('button[type="submit"]');
    if (submitBtn instanceof HTMLButtonElement) submitBtn.disabled = true;

    const formData = new FormData(form);

    fetch(window.Theme.routes.cart_add_url, {
      method: 'POST',
      body: formData,
      headers: {
        Accept: 'application/javascript',
        'X-Requested-With': 'XMLHttpRequest',
      },
    })
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          console.error('Wishlist add to cart failed:', response.message || response.description);
          return;
        }

        const button = form.querySelector('button[type="submit"]');
        const productTitle = button instanceof HTMLElement ? button.dataset.productTitle || '' : '';
        let productImageUrl = button instanceof HTMLElement ? button.dataset.productImage || '' : '';

        if (productImageUrl) {
          try {
            const imgUrl = new URL(productImageUrl, window.location.origin);
            imgUrl.searchParams.set('width', '96');
            productImageUrl = imgUrl.toString();
          } catch {
            productImageUrl = productImageUrl.replace(/([?&])width=\d+/, '$1width=96');
          }
        }

        document.dispatchEvent(
          new CustomEvent('cart:update', {
            bubbles: true,
            detail: {
              resource: {},
              sourceId: 'wishlist-page',
              data: {
                source: 'product-form-component',
                itemCount: Number(formData.get('quantity')) || 1,
                sections: response.sections,
                productTitle,
                productImageUrl,
              },
            },
          })
        );
      })
      .catch((error) => {
        console.error('Wishlist add to cart error:', error);
      })
      .finally(() => {
        if (submitBtn instanceof HTMLButtonElement) submitBtn.disabled = false;
      });
  };

  /** @param {Event} event */
  #handleWishlistChange = (event) => {
    const detail = /** @type {{ handle?: string | null; adding?: boolean | null }} */ (
      /** @type {CustomEvent} */ (event).detail || {}
    );

    if (detail.adding === true || !detail.handle || !this.#grid) return;

    const item = this.#grid.querySelector(`[data-product-handle="${detail.handle}"]`);
    if (item instanceof HTMLElement) {
      item.classList.add('wishlist-page__item--removing');
      window.setTimeout(() => {
        if (item.isConnected) item.remove();
        if (!getWishlistHandles().length) this.#showEmpty();
      }, 200);
    } else if (!getWishlistHandles().length) {
      this.#showEmpty();
    }
  };

  async #render() {
    if (!this.#grid || !this.#empty || this.#loading) return;

    const handles = getWishlistHandles();

    if (!handles.length) {
      this.#showEmpty();
      return;
    }

    this.#loading = true;
    this.#empty.hidden = true;
    this.#grid.hidden = false;
    this.#grid.innerHTML = renderSkeletons(handles.length);

    const validHandles = [];
    const products = [];

    await Promise.all(
      handles.map(async (handle) => {
        try {
          const response = await fetch(`/products/${encodeURIComponent(handle)}.js`, {
            headers: { Accept: 'application/json' },
          });

          if (!response.ok) return;

          const product = await response.json();
          if (!product?.id) return;

          validHandles.push(handle);
          products.push(product);
        } catch {
          /* skip */
        }
      })
    );

    if (validHandles.length !== handles.length) {
      persistWishlist(validHandles);
      window.Wishlist?.syncAllButtons?.();
      window.Wishlist?.updateHeaderBadge?.();
    }

    if (!validHandles.length) {
      this.#grid.innerHTML = '';
      this.#showEmpty();
      this.#loading = false;
      return;
    }

    const productByHandle = new Map(products.map((product) => [product.handle, product]));
    this.#grid.innerHTML = validHandles
      .map((handle) => {
        const product = productByHandle.get(handle);
        return product ? renderProductCard(product, this.#moneyFormat, this.#sectionId) : '';
      })
      .join('');

    window.Wishlist?.syncAllButtons?.();
    this.#loading = false;
  }

  #showEmpty() {
    if (this.#grid) {
      this.#grid.innerHTML = '';
      this.#grid.hidden = true;
    }

    if (this.#empty) {
      this.#empty.hidden = false;
    }
  }
}

const wishlistPage = new WishlistPage();

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => wishlistPage.init());
} else {
  wishlistPage.init();
}
